import { Machine } from './machine'
import { extend } from 'lodash'

export class ReportPhoto {
  url: string = ''
  caption: string = ''

  public get isDataUrl(): boolean {
    return /^data/.test(this.url)
  }
}

export type Company = 'meiwa'|'wnw'

export const Companies = [
  {
    key: 'meiwa',
    label: 'MEIWA'
  },
  {
    key: 'wnw',
    label: 'Work & Work'
  }
]

export class Report extends Machine {
  id: number
  report_date: Date|null
  operating_hours: number|null
  company: Company = 'meiwa'      // or 'wnw'
  content: string = ''            // json
  inspection_json: string = ''    // json
  recommendations: string = ''
  last_update: Date
  date_of_service: Date|null
  client_name: string = ""
  machine_number: string = ""
  model: string = ""
  serial_number: string = ""
  work_details: string[] = []
  photos: ReportPhoto[] = []

  //check_lists
  check_lists!: {[key: string]: any};
  inspection_list!: {[key: string]: any}

  static DEFAULT_CONTENT = {
    work_details: [],
    check_lists: {
      airend : {
        out_of_scope : false,
        oil_seal : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          reused : false
        },
        mechanical_seal : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          reused : false
        },
        gear : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          cleaned : false
        },
        rotor_shaft : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          polished : false
        },
        casing : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          polished : false
        },
        bearings : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          reused : false
        }
      },
      oil_cooler : {
        out_of_scope : false,
        dirt_oil_side : {
          little : false,
          excessive : false,
          cleaned_circulated : false,
          need_cleaning : false
        },
        dirt_air_side : {
          little : false,
          excessive : false,
          cleaned_circulated : false,
          need_cleaning : false
        },
        packing_oring : {
          ok : false,
          not_good : false,
          replaced : false,
          reused : false,
        },
        corrosion : {
          ok : false,
          leak : false,
          replaced : false,
          need_replacement : false,
          air_blow : false
        }
      },
      after_cooler : {
        out_of_scope : false,
        dirt_oil_side : {
          little : false,
          excessive : false,
          cleaned_circulated : false,
          need_cleaning : false
        },
        dirt_air_side : {
          little : false,
          excessive : false,
          cleaned_circulated : false,
          need_cleaning : false
        },
        packing_oring : {
          ok : false,
          not_good : false,
          replaced : false,
          reused : false,
        },
        corrosion : {
          ok : false,
          leak : false,
          replaced : false,
          need_replacement : false,
          air_blow : false
        }
      },
      motor : {
        out_of_scope : false,
        grease : {
          ok : false,
          not_good : false,
          replaced_new_motor : false,
          replaced_new_motor_rotor : false,
          grease_up : false,
          grease_selected : {
            is_checked : false,
            selected_item : ''
          }
        },
        stator : {
          ok : false,
          not_good : false,
          rewinding : false,
          varnish : false,
        },
        noise : {
          ok : false,
          not_good : false,
          changed_bearings : false,
          need_bearings_replacement : false,
        },
        shaft : {
          ok : false,
          not_good : false,
          repaired : false,
          changed_new_shaft : false,
          need_replacement : false,
        },
        others1 : '',
        others2 : ''
      },
      fan_motor : {
        out_of_scope : false,
        resistance : {
          ok : false,
          not_good : false,
          replaced_new_set_of_fan_motor : false,
          rewinding : false,
          varnish_change_need : false,
        },
        bearings : {
          ok : false,
          not_good : false,
          changed_bearings : false,
          replacement : false
        },
        others1 : '',
        others2 : ''
      },
      suction_filter : {
        out_of_scope : false,
        prefilter : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          cleaned : false
        },
        suction_filter_item : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          cleaned : false
        }
      },
      oil_filter : {
        out_of_scope : false,
        element : {
          little : false,
          excessive : false,
          replaced : false,
          need_replacement : false
        }
      },
      oil_separator : {
        out_of_scope : false,
        element : {
          little : false,
          excessive : false,
          replaced : false,
          need_cleaning : false
        },
        tank_dirt : {
          little : false,
          excessive : false,
          replaced : false,
          need_cleaning : false
        },
        magnet_filter : {
          ok : false,
          not_good : false,
          replaced : false,
          reused : false
        }
      },
      pressure_keep_valve : {
        out_of_scope : false,
        function : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          adjusted :false
        },
        oring_packing : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        },
      },
      blow_off_system : {
        out_of_scope : false,
        function : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          cleaned :false
        },
        valve_stem : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        },
        o_ring : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        }
      },
      auto_drain : {
        out_of_scope : false,
        function : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          cleaned : false
        },
        inner_parts : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        }
      },
      auto_thermal_valve : {
        out_of_scope : false,
        thermostat : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          removed : false
        },
        seal_packing : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        }
      },
      oil_recovery : {
        out_of_scope : false,
        check_valve : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          cleaned : false
        }
      },
      volumetric_control_valve_assy : {
        out_of_scope : false,
        function : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false
        },
        valve_seat : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          cleaned : false
        },
        diaphragm : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        },
        cylinder : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          cleaned : false
        },
        cap_seal_oring : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        },
        packing : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        },
      },
      pressure_control_valve : {
        out_of_scope : false,
        function : {
          ok : false,
          not_good : false,
          replaced_full_set : false,
          adjusted : false,
          need_replacement_full_set : false,
          need_replacement_inner_parts : false
        }
      },
      transmission : {
        out_of_scope : false,
        polybelt : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          adjusted : false
        },
        pulley : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        }
      },
      antivacuum_valve : {
        out_of_scope : false,
        function : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
          adjusted : false
        },
        valve_stem : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        },
        o_ring : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        }
      },
      monitor : {
        out_of_scope : false,
        function : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        },
        battery : {
          ok : false,
          not_good : false,
          replaced : false,
          need_replacement : false,
        }
      },
      lubricant_oil : {
        out_of_scope : false,
        ok : false,
        not_good : false,
        replaced : false,
        need_replacement : false,
        top_up : false,
        kobe_screw_oil : {
          is_checked: false,
          selected_item: ''
        },
        customers_oil : false
      },
    },
    photos: [],
  }

  // Added Aug 21, 2018
  // NOTE: `inspection_list` is being saved in seperate field.
  static DEFAULT_INSPECTION_LIST = {
    compressor_proper: {
      out_of_scope: false,
      visual_inspection_1: {
        good: false,
        defective: false,
        replaced: false,
        need_replacement: false
      },
      visual_inspection_2: {
        good: false,
        defective: false,
        replaced: false,
        need_replacement: false
      },
      balance_piston_diaphragm: {
        good: false,
        hardened: false,
        replaced: false,
        need_replacement: false
      },
      abnormal_noise: {
        normal: false,
        abnormal: false
      },
      abnormal_vibration: {
        normal: false,
        abnormal: false
      },
      leakage: {
        little: false,
        excessive: false
      },
      other: ''
    },
    suction_filter: {
      out_of_scope: false,
      contamination: {
        little: false,
        excessive: false,
        cleaned: false,
        replaced: false,
        need_replacement: false
      }
    },
    suction_duct: {
      out_of_scope: false,
      contamination: {
        little: false,
        excessive: false,
        cleaned: false
      },
      breakage: {
        normal: false,
        crack: false,
        hardened: false,
        replaced: false,
        need_replacement: false
      },
    },
    oil_filter: {
      out_of_scope: false,
      foreign_matter: {
        little: false,
        excessive: false,
        replaced: false,
        need_replacement: false
      }
    },
    lubricant_oil: {
      out_of_scope: false,
      ok: false,
      not_good: false,
      replaced: false,
      need_replacement: false,
      top_up: false,
      kobe_screw_oil: {
        is_checked: false,
        selected_item: ''
      },
      customers_oil: false
    },
    drain_solenoid_valve: {
      out_of_scope: false,
      intercooler_drain: {
        normal: false,
        defective: false,
        replaced: false,
        need_replacement: false
      },
      aftercooler_drain: {
        normal: false,
        defective: false,
        replaced: false,
        need_replacement: false
      }
    },
    discharge_check_valve: {
      out_of_scope: false,
      wear_in_seal_surface: {
        normal: false,
        leak: false,
        wear: false,
        replaced: false,
        need_replacement: false
      }
    },
    three_way_solenoid_valve: {
      out_of_scope: false,
      operation: {
        normal: false,
        defective: false,
        replaced: false,
        need_replacement: false
      }
    },
    exhaust_cleaner: {
      out_of_scope: false,
      damage: {
        little: false,
        excessive: false,
        replaced: false,
        need_replacement: false
      }
    },
    capacity_control_valve: {
      out_of_scope: false,
      diaphragm: {
        normal: false,
        torn: false,
        hardened: false,
        replaced: false,
        need_replacement: false
      },
      slider: {
        normal: false,
        wear: false,
        replaced: false,
        need_replacement: false
      },
      lock_nut: {
        normal: false,
        wear: false,
        replaced: false,
        need_replacement: false
      },
      slider_shaft: {
        normal: false,
        damaged: false,
        replaced: false,
        need_replacement: false
      },
      operation: {
        normal: false,
        defective: false,
        changed_new_capacity_control_valve: false
      }
    },
    shutter_valve: {
      out_of_scope: false,
      operation: {
        normal: false,
        defective: false,
        replaced: false,
        need_replacement: false
      }
    },
    intercooler: {
      out_of_scope: false,
      replaced_full_set: false,
      need_replacement_full_set: false,
      other: '',
      scale_adhering: {
        little: false,
        excessive: false,
        dissembled_and_cleaned: false,
        chemical_circulation: false
      },
      corrosion_of_shell: {
        little: false,
        excessive: false,
        replaced: false,
        repaired: false,
        need_replacement: false
      },
      corrosion_of_tube_assy: {
        little: false,
        excessive: false,
        replaced: false,
        repaired: false,
        need_replacement: false
      },
      corrosion_of_covers: {
        little: false,
        excessive: false,
        replaced: false,
        repaired: false,
        need_replacement: false
      },
      contamination: {
        little: false,
        excessive: false,
        dissembled_and_cleaned: false,
        need_replacement: false
      },
      packings: {
        normal: false,
        hardened: false,
        replaced: false,
        need_replacement: false
      }
    },
    aftercooler: {
      out_of_scope: false,
      replaced_full_set: false,
      need_replacement_full_set: false,
      other: '',
      scale_adhering: {
        little: false,
        excessive: false,
        dissembled_and_cleaned: false,
        chemical_circulation: false
      },
      corrosion_of_shell: {
        little: false,
        excessive: false,
        replaced: false,
        repaired: false,
        need_replacement: false
      },
      corrosion_of_tube_assy: {
        little: false,
        excessive: false,
        replaced: false,
        repaired: false,
        need_replacement: false
      },
      corrosion_of_covers: {
        little: false,
        excessive: false,
        replaced: false,
        repaired: false,
        need_replacement: false
      },
      contamination: {
        little: false,
        excessive: false,
        dissembled_and_cleaned: false,
        need_replacement: false
      },
      packings: {
        normal: false,
        hardened: false,
        replaced: false,
        need_replacement: false
      }
    },
    oil_cooler: {
      out_of_scope: false,
      replaced_full_set: false,
      need_replacement_full_set: false,
      other: '',
      clogging: {
        little: false,
        excessive: false,
        replaced: false,
        need_replacement: false
      },
      contamination: {
        little: false,
        excessive: false,
        replaced: false,
        need_replacement: false
      },
      corrosion: {
        little: false,
        excessive: false,
        replaced: false,
        repaired: false,
        need_replacement: false
      },
      packings: {
        normal: false,
        hardened: false,
        replaced: false,
        reused: false
      }
    },
    sensor: {
      out_of_scope: false,
      other: '',
      dis_1: {
        normal: false,
        error: false,
        mpa: null,
        replaced: false,
        need_replacement: false
      },
      dis_2: {
        normal: false,
        error: false,
        mpa: null,
        replaced: false,
        need_replacement: false
      },
      oil: {
        normal: false,
        error: false,
        mpa: null,
        replaced: false,
        need_replacement: false
      },
      stage_temp_1: {
        normal: false,
        error: false,
        celcius: null,
        replaced: false,
        need_replacement: false
      },
      stage_temp_2: {
        normal: false,
        error: false,
        celcius: null,
        replaced: false,
        need_replacement: false
      },
      oil_temp: {
        normal: false,
        error: false,
        celcius: null,
        replaced: false,
        need_replacement: false
      },
    },
    motor: {
      out_of_scope: false,
      other: '',
      stator: {
        normal: false,
        low_resistance: false,
        burnt: false,
        rewind: false,
        cleaned: false,
        need_cleaning: false
      },
      bearings: {
        normal: false,
        defect: false,
        changed_bearing: false,
        need_bearing_change: false
      },
    },
    fan_motor: {
      out_of_scope: false,
      replaced_full_set: false,
      need_replacement_full_set: false,
      other: '',
      stator: {
        normal: false,
        low_resistance: false,
        burnt: false,
        rewind: false,
        cleaned: false,
        need_cleaning: false
      },
      bearings: {
        normal: false,
        defect: false,
        changed_bearing: false,
        need_bearing_change: false
      },
    },
  }

  constructor(raw?:{[id:string]: any}) {
    super(raw)
    this.id = raw && +raw.id || 0
    this.company = raw && raw.company || 'meiwa'
    this.machine_number = raw && raw.machine_number || ''
    this.model = raw && raw.model || ''
    this.serial_number = raw && raw.serial_number || ''
    this.client_name = raw && raw.client_name || ''
    this.report_date = raw && new Date(raw.report_date) || new Date()
    this.operating_hours = raw && +raw.operating_hours || null
    this.last_update = raw && raw.last_update || new Date()
    this.date_of_service = raw && new Date(raw.date_of_service) || new Date()
    this.work_details = raw && raw.work_details || ''
    this.recommendations = raw && raw.recommendations || ''

    // For Content & Inspection List
    this.content = raw && raw.content || JSON.stringify(Report.DEFAULT_CONTENT)
    this.inspection_json = raw && raw.inspection_json || JSON.stringify(Report.DEFAULT_INSPECTION_LIST)

    // Parse content (update check_lists, inspection_list)
    this._parseContent()
  }

  static clone(from:Report): Report {
    // Make sure from object has correct content payload.
    from._stringifyToContent()
    return new Report(from)
  }

  private _parseContent() {
    // ** Raw Content Parsing **

    // JSON: `content` => {work_details, check_lists, photos}
    const parsed = JSON.parse(this.content)
    this.check_lists = parsed.check_lists
    this.work_details = parsed.work_details || []
    this.photos = (parsed.photos || []).map((photo: any) => Object.assign(new ReportPhoto(), photo))

    // JSON: `inspection_json` => Inspection List
    // copy via json's parsing.
    this.inspection_list = JSON.parse(JSON.stringify(Report.DEFAULT_INSPECTION_LIST))
    this.inspection_list = extend(this.inspection_list, JSON.parse(this.inspection_json))

    // ** Migration **

    // (1) `check_lists`
    // Change 'kobe_screw_oil' from 'boolean' to 'LOV:lubricant'
    if (typeof this.check_lists.lubricant_oil.kobe_screw_oil === 'boolean') {
      this.check_lists.lubricant_oil.kobe_screw_oil = {
        is_checked: false,
        selected_item: ''
      }
    }
  }
  
  private _stringifyToContent() {
    this.content = JSON.stringify({
      check_lists: this.check_lists,
      work_details: this.work_details,
      photos: this.photos
    })
    this.inspection_json = JSON.stringify(this.inspection_list)
  }

  toJson() {
    this._stringifyToContent()
    return {
      id: this.id,
      client_name: this.client_name,
      machine_number: this.machine_number,
      serial_number: this.serial_number,
      model: this.model,
      report_date: this.report_date,
      operating_hours: +(this.operating_hours || 0),
      content: this.content,
      inspection_json: this.inspection_json,
      last_update: this.last_update,
      date_of_service: this.date_of_service,
      company: this.company,
      recommendations: this.recommendations
    }
  }
}